export default class ProductListGalleryContent {
    private shownImageUrl: string | undefined;

    constructor(
        private readonly galleryContainer: HTMLDivElement,
        private readonly images: string[],
        private readonly mobileImages: string[],
    ) {
        if (images.length > 0) {
            this.shownImageUrl = images[0];
        }
    }

    public getGalleryContainer(): HTMLDivElement {
        return this.galleryContainer;
    }

    public getMobileImageUrlByIndex(index: number): string {
        return this.mobileImages[index];
    }

    public getImagesCount(): number {
        return this.images.length;
    }

    public setShownImageUrl(imageUrl: string): void {
        this.shownImageUrl = imageUrl;
    }

    public getShownImageIndex(): number {
        if (this.shownImageUrl === undefined) {
            throw new Error("No shown image");
        }

        const shownImageIndex = this.images.indexOf(this.shownImageUrl);

        if (shownImageIndex !== -1) {
            return shownImageIndex;
        }

        const showMobileImageIndex = this.mobileImages.indexOf(this.shownImageUrl);

        if (showMobileImageIndex !== -1) {
            return showMobileImageIndex;
        }

        throw new Error("Unknown shown image");
    }
}
